<template>
  <v-card :loading="loading">
    <v-card-title class="font-weight-regular">
      {{ $t('EMPLOYEES.CONTACT_INFORMATION') }}
      <v-icon
        v-if="!editMode"
        class="ml-2"
        color="indigo"
        @click="toggleEditMode"
      >
        mdi-square-edit-outline
      </v-icon>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <employee-contact-information-form
          v-model="form.contacts"
          :readonly="!editMode"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />

        <v-row dense>
          <v-col cols="12" class="pt-0">
            <div v-if="editMode">
              <v-btn
                outlined
                class="mr-5"
                depressed
                color="grey"
                large
                v-on="{
                  click: [reset, cancel]
                }"
              >
                {{ $t('BUTTON.CANCEL') }}
              </v-btn>
              <v-btn
                depressed
                type="submit"
                :disabled="!valid"
                large
                color="primary"
                class="mr-5"
                @click.prevent="update"
              >
                {{ $t('BUTTON.UPDATE') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import errors from '@/modules/_global/mixins/errors';
import EmployeeContactInformationForm from '../components/forms/EmployeeContactInformationForm.vue';
import editComponent from '@/modules/_global/mixins/edit-component';
import { EmployeesService } from '@/services/employees.service';

export default {
  name: 'EmployeeContactInformation',

  components: {
    EmployeeContactInformationForm
  },

  mixins: [errors, editComponent],

  methods: {
    update() {
      EmployeesService.updateContacts(this.form.id, this.form.contacts)
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.toggleEditMode();
          this.$emit('update', data);
        })
        .catch(this.handleErrors);
    }
  }
};
</script>
